/**
 * A promise that resolves to `value` after `durationMs`, plus a `cancel()` that
 * clears the timer. Used to bound the LLM reconciliation with `Promise.race` so a
 * stalled proxy can't hang the celebration CTA; cancel() stops the timer from
 * firing into the void once the race is decided.
 */
export function timeoutTo<TValue>(durationMs: number, value: TValue): { promise: Promise<TValue>; cancel: () => void } {
  let handle: ReturnType<typeof setTimeout> | undefined;

  const promise = new Promise<TValue>((resolve) => {
    handle = setTimeout(() => resolve(value), durationMs);
  });

  return { promise, cancel: () => clearTimeout(handle) };
}
